import { motion } from 'framer-motion';
import { Button } from '../../ui/Button/Button';
import { Reveal } from '../../ui/Reveal/Reveal';
import './CTA.css';

export function CTA() {
  return (
    <section id="contact" className="section cta">
      <div className="cta__orb cta__orb--a" />
      <div className="cta__orb cta__orb--b" />

      <div className="container cta__inner">
        <Reveal>
          <span className="eyebrow">Begin</span>
        </Reveal>

        <Reveal delay={0.1}>
          <h2 className="cta__title">
            Have an event<br />
            <span className="italic-accent">in mind?</span>
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="cta__lede">
            Tell us the brief in a sentence. We'll come back within 24 hours with the right lead, a
            point of view and the next three questions worth asking.
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="cta__actions">
            <Button href="/contact">Send brief</Button>
            <Button variant="ghost" href="mailto:luminarentertainments123@gmail.com">
              luminarentertainments123@gmail.com
            </Button>
          </div>
        </Reveal>

        <motion.div
          className="cta__meta"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.5 }}
        >
          <div className="cta__meta-col">
            <span className="cta__meta-label">Aluva, Kerala</span>
            <span className="cta__meta-value">+91 81290 77431</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
